import { z } from "zod";
import {
  BUDGET_NAME,
  LAST_UPDATED_BY,
  LAST_UPDATED_ON,
  LINE_ITEMS_COUNT,
  NOTES,
  TOTAL_ANNUAL_BUDGET,
  TOTAL_APPROVALS,
  VERSION_NO,
  YEAR,
} from "./consts";

export const schema = z.object({
  [BUDGET_NAME]: z
    .string()
    .min(3, "Minimum 3 characters are required for this field"),
  [VERSION_NO]: z.string().min(1, "This field is required"),
  [YEAR]: z.string().min(1, "This field is required"),
  [TOTAL_ANNUAL_BUDGET]: z.string().optional(),
  [TOTAL_APPROVALS]: z.string().optional(),
  [NOTES]: z.string().min(1, "This field is required"),
  [LAST_UPDATED_BY]: z.string().optional(),
  [LAST_UPDATED_ON]: z.string().optional(),
  [LINE_ITEMS_COUNT]: z.string().optional(),
});

export type formValues = z.infer<typeof schema>;
